// campaignService.js
import { apiRequest } from '../api';
import { CAMPAIGN } from '../endPoints';

export const wcaGetCampaigns = (
  metadataId,
  pageNo = 0,
  limit = 10,
  startDate,
  endDate,
  globalFilterValue,
) => {
  const params = {
    page: pageNo,
    limit,
  };
  if (startDate && endDate) {
    params.fromDate = startDate;
    params.toDate = endDate;
  }

  if (globalFilterValue) {
    params.search = globalFilterValue;
  }

  return apiRequest('get', CAMPAIGN.GET_CAMPAIGNS(metadataId), null, params);
};

export const wcaCreateCampaign = (metadataId, data) => {
  return apiRequest('post', CAMPAIGN.CREATE_CAMPAIGN(metadataId), data);
};

export const wcaGetCampaignById = (metadataId, campaignId) => {
  return apiRequest('get', CAMPAIGN.GET_CAMPAIGN_BY_ID(metadataId, campaignId));
};
export const wcaGetCampaignAnalytics = (metadataid, campaignId, page, limit, status) => {
  const params = {
    page,
    limit,
  };
  if (status) {
    params.status = status;
  }
  return apiRequest('get', CAMPAIGN.GET_CAMPAIGNS_ANALYTICS(metadataid, campaignId), null, params);
};
